"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxAdapter = void 0;
var array_1 = require("./array");
var utils_1 = require("../utils");
var request_1 = require("../utils/request");
var is_nil_1 = require("../utils/is-nil");
var AjaxAdapter = /** @class */ (function (_super) {
    __extends(AjaxAdapter, _super);
    function AjaxAdapter(element, options) {
        var _this = _super.call(this, element, options) || this;
        _this.ajaxOptions = _this._applyDefaults(options.get('ajax'));
        if (!is_nil_1.isNil(_this.ajaxOptions.processResults)) {
            _this.processResults = _this.ajaxOptions.processResults;
        }
        else {
            _this.processResults = function (results) { return results; };
        }
        return _this;
    }
    AjaxAdapter.prototype.select = function (data) {
        data.selected = true;
        _super.prototype.select.call(this, data);
    };
    AjaxAdapter.prototype.query = function (params, callback) {
        var self = this;
        if (this._request != null) {
            // JSONP requests cannot always be aborted
            if (typeof this._request.abort === 'function') {
                this._request.abort();
            }
            this._request = null;
        }
        var options = utils_1.extend({
            type: 'GET'
        }, this.ajaxOptions);
        if (typeof options.url === 'function') {
            options.url = options.url.call(this.core.element, params);
        }
        if (typeof options.data === 'function') {
            options.data = options.data.call(this.core.element, params);
        }
        function request() {
            var $request = options.transport(options, function (data) {
                var results = self.processResults(data.data, params);
                if (self.options.get('debug') && window.console && console.error) {
                    // Check to make sure that the response included a `results` key.
                    if (!results || !results.results || !Array.isArray(results.results)) {
                        console.error('Select2: The AJAX results did not return an array in the ' +
                            '`results` key of the response.');
                    }
                }
                callback(results);
            }, function () {
                // Attempt to detect if a request was aborted
                // Only works if the transport exposes a status property
                if ($request && 'status' in $request &&
                    ($request.status === 0 || $request.status === '0')) {
                    return;
                }
                self.trigger('results:message', {
                    message: 'errorLoading'
                });
            });
            self._request = $request;
        }
        if (this.ajaxOptions.delay && params.term != null) {
            if (this._queryTimeout) {
                window.clearTimeout(this._queryTimeout);
            }
            this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
        }
        else {
            request();
        }
    };
    AjaxAdapter.prototype._applyDefaults = function (options) {
        var defaults = {
            data: function (params) {
                return utils_1.extend({}, params, {
                    q: params.term
                });
            },
            transport: function (params, success, failure) {
                var $request = request_1.default(params);
                $request.then(success);
                $request.catch(failure);
                return $request;
            }
        };
        return utils_1.extend({}, defaults, options, true);
    };
    return AjaxAdapter;
}(array_1.ArrayAdapter));
exports.AjaxAdapter = AjaxAdapter;
//# sourceMappingURL=ajax.js.map